import axios from 'axios';
import { APIEndpoints } from 'helpers/APILists';
import _, { isEqual } from 'lodash';
import { set } from 'idb-keyval';
import offlineStore from 'utils/OfflineDB';
import { TEST_ACTIONS } from '../TestEquipment.constants';
import { searchTestEquipment, sortTestEquipment, getTestMakeModelData } from '../TestEquipment.actions';
import { MESSAGE_TYPE } from '../../../common/common.constants';
import { errorMsg } from 'journeys/portal/Forms/TRFImaging.actions';

export const setDataForAddTestEquipment = (initialState) => (dispatch) => {
    dispatch({
        type: TEST_ACTIONS.ADDTESTEQUIPMENT_SET_INITIALDATA,
        payload: {
            addTestEquipmentData: initialState
        }
    });
};

const trimTEIData = (teiData) => {
    const teiDataObject = teiData;
    for (const key in teiDataObject) {
        if (typeof teiDataObject[key] === 'string' && key !== 'CalDueDate') {
            teiDataObject[key] = teiDataObject[key]?.trim();
        }
    }
    return teiDataObject;
};

const displayTestEquipmentUnSavedChangesLabel = () => (dispatch, getState) => {
    const { TestEquipment: { editTestEquipmentData }, TestEquipment: { testEquipmentDataAll } } = getState();
    let originalData = testEquipmentDataAll.find(x => x.Rowid === editTestEquipmentData.Rowid);
    originalData = { ...originalData, CalDueDate: new Date(originalData.CalDueDate).setHours(0, 0, 0, 0), Notes: originalData.Notes ?? '' };
    const modifiedData = { ...editTestEquipmentData, CalDueDate: new Date(editTestEquipmentData.CalDueDate).setHours(0, 0, 0, 0), Notes: editTestEquipmentData.Notes ?? '' };
    delete modifiedData.IsCellRedClass;
    delete modifiedData.FormDeviceType;
    delete modifiedData.FormManufacturer;
    delete modifiedData.FormModel;
    const labelState = isEqual(originalData, modifiedData);
    dispatch({
        type: TEST_ACTIONS.UPDATETESTEQUIPMENT_UNSAVED_CHANGES_LABEL,
        payload: {
            unSavedChangesTE: !labelState
        }
    });
};

export const resetDataForAddTestEquipment = (initialState) => (dispatch) => {
    dispatch({
        type: TEST_ACTIONS.ADDTESTEQUIPMENT_RESET_DATA,
        payload: {
            addTestEquipmentData: initialState
        }
    });
};

export const updateDataForAddTestEquipment = (changeObj) => (dispatch) => {
    dispatch({
        type: TEST_ACTIONS.ADDTESTEQUIPMENT_UPDATE_DATA,
        payload: {
            ...changeObj
        }
    });
};

export const setDataForEditTestEquipment = (existingState) => (dispatch) => {
    dispatch({
        type: TEST_ACTIONS.EDITTESTEQUIPMENT_SET_EXISTINGDATA,
        payload: {
            editTestEquipmentData: existingState,
        }
    });
};

export const resetDataForEditTestEquipment = () => (dispatch, getState) => {
    const { TestEquipment: { editTestEquipmentData }, TestEquipment: { testEquipmentDataAll } } = getState();
    dispatch({
        type: TEST_ACTIONS.EDITTESTEQUIPMENT_RESET_DATA,
        payload: {
            editTestEquipmentData: testEquipmentDataAll.find(x => x.Rowid === editTestEquipmentData.Rowid),
            unSavedChangesTE: false
        }
    });
};

export const updateDataForEditTestEquipment = (changeObj) => (dispatch) => {
    dispatch({
        type: TEST_ACTIONS.EDITTESTEQUIPMENT_UPDATE_DATA,
        payload: {
            ...changeObj
        }
    });
    dispatch(displayTestEquipmentUnSavedChangesLabel());
};

const searchTestEqData = (dispatch, searchStringForTestEq, sortColumn, sortDeviceTypeAscOrder, sortStatusAscOrder) => {
    searchStringForTestEq && dispatch(searchTestEquipment(searchStringForTestEq));
    !searchStringForTestEq && sortColumn && (sortColumn === 'DeviceType' ? dispatch(
        sortTestEquipment(sortColumn, sortDeviceTypeAscOrder))
        : dispatch(sortTestEquipment(sortColumn, sortStatusAscOrder)));
};
export const PostAddTestEquipmentData = (obj) => async (dispatch, getState) => {
    const { TestEquipment: { searchStringForTestEq, sortColumn, sortDeviceTypeAscOrder, testEquipmentDataAll, sortStatusAscOrder } } = getState();
    dispatch({
        type: TEST_ACTIONS.ADD_TESTEQUIPMENTRECORD_PENDING,
        payload: {
            tableLoading: true
        }
    });
    const modifiedAddTestEquipmentData = { ...obj, CalDueDate: new Date(obj.CalDueDate).toLocaleDateString('en-US') };
    const postData = trimTEIData(modifiedAddTestEquipmentData);
    await axios.post(APIEndpoints.SaveTestEq, postData)
        .then((res) => {
            dispatch({
                type: TEST_ACTIONS.ADD_TESTEQUIPMENTRECORD_SUCCESS,
                payload: {
                    tableLoading: false,
                    addTestEquipmentData: res.data
                }
            });
            dispatch(getTestMakeModelData()).then(() => {
                searchTestEqData(dispatch, searchStringForTestEq, sortColumn, sortDeviceTypeAscOrder, sortStatusAscOrder);
            });
        })
        .catch((err) => {
            if (err.message === errorMsg) {
                const offlineObject = {
                    url: err.config.url,
                    body: postData,
                    requestType: 'POST'
                };
                let offlineDataPost;
                if (_.find(testEquipmentDataAll, item => item.DeviceType === postData.DeviceType && (!item.Rowid || item.Rowid === ''))) {
                    offlineDataPost = testEquipmentDataAll.map(itemObj => itemObj.DeviceType === postData?.DeviceType && !itemObj.Rowid ? postData : itemObj);
                } else {
                    offlineDataPost = [...testEquipmentDataAll, postData];
                }
                set(`POST_TestEquipment_${postData.DeviceType}`, offlineObject, offlineStore)
                    .then(() => {
                        dispatch({
                            type: TEST_ACTIONS.GET_TEST_MAKE_MODEL_DATA_SUCCESS,
                            payload: {
                                testEquipmentDataAll: offlineDataPost,
                                tableLoading: false
                            }
                        });
                        searchTestEqData(dispatch, searchStringForTestEq, sortColumn, sortDeviceTypeAscOrder, sortStatusAscOrder);
                    })
                    .catch((offlineErr) => {
                        dispatch({
                            type: TEST_ACTIONS.ADD_TESTEQUIPMENTRECORD_FAILURE,
                            payload: {
                                tableLoading: false,
                            },
                            meta: { messageType: MESSAGE_TYPE.ERROR, message: offlineErr.message, exception: offlineErr }
                        });
                    });
            } else {
                dispatch({
                    type: TEST_ACTIONS.ADD_TESTEQUIPMENTRECORD_FAILURE,
                    payload: {
                        tableLoading: false,
                    },
                    meta: { messageType: MESSAGE_TYPE.ERROR, message: err.message, exception: err }
                });
            }
        });
};

export const PutEditTestEquipmentData = (obj) => async (dispatch, getState) => {
    const { TestEquipment: { editTestEquipmentData, testEquipmentDataAll, searchStringForTestEq, sortColumn, sortDeviceTypeAscOrder, sortStatusAscOrder } } = getState();
    dispatch({
        type: TEST_ACTIONS.EDIT_TESTEQUIPMENTRECORD_PENDING,
        payload: {
            tableLoading: true,
        }
    });
    const modifiedEditTestEquipmentData = { ...obj, CalDueDate: new Date(editTestEquipmentData.CalDueDate).toLocaleDateString('en-US') };
    const postData = trimTEIData(modifiedEditTestEquipmentData);
    const offlineData = testEquipmentDataAll.map(itemObj => itemObj.Rowid === postData.Rowid ? postData : itemObj);
    await axios.put(APIEndpoints.SaveTestEq, postData)
        .then((res) => {
            dispatch({
                type: TEST_ACTIONS.EDIT_TESTEQUIPMENTRECORD_SUCCESS,
                payload: {
                    tableLoading: false
                }
            });
            dispatch(getTestMakeModelData()).then(() => {
                searchTestEqData(dispatch, searchStringForTestEq, sortColumn, sortDeviceTypeAscOrder, sortStatusAscOrder);
            });
        })
        .catch((err) => {
            if (err.message === errorMsg) {
                const offlineObject = {
                    url: err.config.url,
                    body: postData,
                    requestType: 'PUT'
                };
                set(`PUT_TestEquipment_${postData.Rowid}`, offlineObject, offlineStore)
                    .then(() => {
                        dispatch({
                            type: TEST_ACTIONS.GET_TEST_MAKE_MODEL_DATA_SUCCESS,
                            payload: {
                                testEquipmentDataAll: offlineData,
                                tableLoading: false
                            }
                        });
                        searchTestEqData(dispatch, searchStringForTestEq, sortColumn, sortDeviceTypeAscOrder, sortStatusAscOrder);
                    })
                    .catch((error) => {
                        dispatch({
                            type: TEST_ACTIONS.EDIT_TESTEQUIPMENTRECORD_FAILURE,
                            payload: {
                                tableLoading: false,
                            },
                            meta: { messageType: MESSAGE_TYPE.ERROR, message: error.message, exception: error }
                        });
                    });
            } else {
                dispatch({
                    type: TEST_ACTIONS.EDIT_TESTEQUIPMENTRECORD_FAILURE,
                    payload: {
                        tableLoading: false,
                    },
                    meta: { messageType: MESSAGE_TYPE.ERROR, message: err.message, exception: err }
                });
            }
        });
};
